import { useEffect, useState } from "react";

function useCachedValueIfNotNull<T>(value: T | undefined, isCached: boolean, defaultValue: T): T {

    const [serverCompanies, setServerCompanies] = useState<T>(defaultValue);
    useEffect(() => {
        if (!isCached && value) {
            setServerCompanies(value);
        }
    }, [value, isCached]);

    return serverCompanies;
}

export default useCachedValueIfNotNull;